import type { ClientOptions } from 'graphql-ws';

/** Finite transport recovery; graphql-ws still rejects its fatal close codes
 * before this retry predicate, including unauthorised and malformed clients. */
export const realtimeRetryOptions: Pick<ClientOptions, 'retryAttempts' | 'retryWait' | 'shouldRetry'> = {
  // 361–365 seconds of backoff: a five-minute development restart can
  // recover before exhaustion, while a persistent outage still surfaces.
  retryAttempts: 16,
  shouldRetry: () => true,
  retryWait: (retries: number) => new Promise(resolve => setTimeout(resolve, Math.min(30_000, 1000 * 2 ** retries) + Math.random() * 250)),
};
